import { BehaviorSubject, Subscription } from "rxjs";
import { Observable } from "rxjs";
import { Component, OnInit, Input, Output, EventEmitter, NgZone } from "@angular/core";
import { UserRolesService } from "src/app/services/settings-services/user-roles.service";
import { GeneralService } from "src/app/services/general.service";
import { environment } from "src/environments/environment";
import { BillingService } from "src/app/registration/services/billing.service";
import * as $ from "jquery";


@Component({
  selector: "app-add-more-users-to-license",
  templateUrl: "./addMoreUsers.component.html",
  styleUrls: ["./addMoreUsers.component.css"],
})
export class AddMoreUsersToLicenseComponent implements OnInit {

  @Input() licencesDataSource;
  @Input() numberOfUser;
  @Input() selectedBillingId;
  @Input() upgradeLoading;
  @Input() org;
  @Input() user;
  @Output() callback: EventEmitter<any> = new EventEmitter<any>(null);
    currentLicense: any;
    userCostValue;

  constructor(
    private userRoles: UserRolesService,
    private gs: GeneralService,
    private ngZone: NgZone,
    public billingService: BillingService
  ) { }

  ngOnInit() {

  }

  onSelectBilling($event){

    this.currentLicense = $event;
    this.getUserValue(this.numberOfUser);
  }

  getUserValue(numberOfUser) {
    const {id} = this.currentLicense;
    if(id && id > 0 && numberOfUser && numberOfUser > 0 && this.selectedBillingId > 0){
      this.upgradeLoading = true;
      this.userRoles.getAdditionalUserValueByBill(numberOfUser, id).subscribe((response: any) => {
        this.userCostValue = response.payload;
        this.upgradeLoading = false;
      })
    }
  }

  proceed(){
    this.paystackInit();
    // this.callback.emit({ type: "selectedrows", data: {} });
  }
  OnDestroy() {
  }

  toastMessage: string = '';
  showToast(message: string) {
    this.toastMessage = message;
    setTimeout(() => this.toastMessage = '', 3000);
  }

  paystackInit() {
    if (this.selectedBillingId === 0) {
      this.showToast("No License was selected");

      return;
    }
    const bills = this.licencesDataSource.filter(function(b){ return b.id === Number(this.selectedBillingId); }, this);
    if (!bills || bills.length === 0) {

      this.showToast("No License was selected from list");
      return;
    }

    this.currentLicense = bills[0];
    const winPaystackPop = (window as any).PaystackPop;
    const currency = this.currentLicense.currency;
    const paymentMethod = this.currentLicense.paymentMethod;
    const licenseID = this.currentLicense.licenseID;

    const baseMeta = {
      orgId: this.org.id,
      licenseId: licenseID,
      userID: this.user.id,
      numberOfUsers: this.numberOfUser,
      referrer: window.origin + '/reg/plans',
      tenantEmail: this.org.email,
      tenantName: this.org.name,
      autoRenew: false,
      billPlanType: paymentMethod,
      paymentType: 'ADD_MORE_USERS_TO_LICENSE'
    };

    const licenseItem = {
      orgId: baseMeta.orgId,
      tenantName: baseMeta.tenantName,
      tenantEmail: baseMeta.tenantEmail,
      billPlanType: baseMeta.billPlanType,
      autoRenew: baseMeta.autoRenew,
      numberOfUsers: baseMeta.numberOfUsers,
      licenseId: baseMeta.licenseId,
      billingId: this.currentLicense.id,
      name: this.currentLicense.license || this.currentLicense.licenseName || '',
      licenseName: this.currentLicense.license || this.currentLicense.licenseName || '',
      monthlyPrice: this.currentLicense.monthlyPrice || this.currentLicense.amount || 0,
      annuallyPrice: this.currentLicense.annuallyPrice || 0,
      addons: [],
      paymentType: 'ADD_MORE_USERS_TO_LICENSE'
    };

    const amount = Math.round(this.userCostValue.cost * 100);

    if (winPaystackPop) {
      const handler = winPaystackPop.setup({
        key: environment.paystackKey,
        email: this.org.email,
        amount: amount,
        metadata: baseMeta,
        currency: currency,
        callback: (response: any) => this.ngZone.run(() => {
          const wrapped = {
            currency: currency,
            gateway_response: response && response.gateway_response ? response.gateway_response : 'Successful',
            reference: response && response.reference ? response.reference : '',
            metadata: {
              userID: baseMeta.userID,
              licenses: [licenseItem]
            }
          };
          this.billingService.createBillings(wrapped).subscribe({
            next: () => {
              this.gs.sweetAlertSuccess('Success', 'Users added and billing saved');
              this.numberOfUser = null;
              this.selectedBillingId = 0;
              // Emit callback to parent component to refresh data
              this.callback.emit({ type: "success", data: { action: "addMoreUsers" } });
              // Close modal
              $("#closeUpgradeBtn").click();
            },
            error: (err: any) => {
              const msg = this.gs.getErrMsg(err) || 'Failed to save billing';
              this.gs.sweetAlertError(msg);
            }
          });
        })
      });
      handler.openIframe();
    } else {
      const swtData = { title: 'Oops!', html: 'Network error occurred, reload page and try again' };
      this.gs.sweetAlertHTML(swtData.title, swtData.html);
    }
  }

  confirmPayment(response) {
    const { id: orgId } = this.org;
    const payload = { reference: response.reference, orgId };
    this.upgradeLoading = true;
    this.billingService.comfirmPaystackPayment(payload.reference).subscribe(res => {
      if (res.payload && res.payload.data.status == 'success') {
        this.numberOfUser = ""
        $("#closeUpgradeBtn").click();
        this.gs.sweetAlertSucess('Payment  successful')
        // this.updateOrgLicense(res);
      } else {
        this.gs.sweetAlertHTML('Payment Status', 'Payment not successful')
      }
    }, err => {
      this.gs.sweetAlertError(this.gs.getErrMsg(err));
    }).add(() => {
      this.upgradeLoading = false
    })
  }
}
